import BaseHeadline from '../../../components/general/BaseHeadline'
import { SoftwareCardType } from '../../../types/index'
import { SoftwareCard } from './SoftwareCard'
import { useNavigate } from 'react-router-dom'




export default function SoftwareSolutions(props: any) {
    const navigate = useNavigate()
    const cards = (props.previewCards ?? [])
        .map((item: any) => ({
            ...(item?.attributes?.previewCard ?? {}),
            id: item?.id,
        }))
        .filter((item: any) => item?.id && item?.title)

    return (
        <section className="py-20 px-4 sm:px-8 xl:px-0">
            <div className="max-w-page mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start relative">
                    <div className="w-full col-span-1 lg:col-span-5 lg:sticky lg:top-44 self-start">
                        <BaseHeadline
                            headline={props.data?.heading.headline}
                            text={props.data?.heading.text}
                            tag="h2"
                            textClassProps="max-w-xl"
                        />
                    </div>
                    <div className='hidden lg:block' />

                    <div className="w-full col-span-1 lg:col-span-6 flex flex-col gap-8 lg:gap-11">
                        {cards.map((solution: SoftwareCardType & { id: number }, index: number) => (
                            <SoftwareCard
                                key={`${solution.id}-${solution.title}`}
                                title={solution.title}
                                subtitle={solution.subtitle}
                                description={solution.text}
                                icon={solution.lucideIcon}
                                color={index % 2 === 0 ? 'blue' : 'orange'}
                                align={index % 2 === 0 ? 'left' : 'right'}
                                onClick={() => navigate(`/software/${solution.id}`)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
